import { useState, useCallback } from 'react';

export const useExpenseData = () => {
  const [expenses, setExpenses] = useState([]);

  const addExpense = useCallback((newExpense) => {
    setExpenses(prev => [
      { ...newExpense, id: newExpense.id ?? Date.now() },
      ...prev,
    ]);
  }, []);

  // Bulk insert — used by CSV import
  const addExpenses = useCallback((newExpenses) => {
    const now = Date.now();
    setExpenses(prev => [
      ...newExpenses.map((e, i) => ({ ...e, id: e.id ?? now + i })),
      ...prev,
    ]);
  }, []);

  const updateExpense = useCallback((updatedExpense) => {
    setExpenses(prev => prev.map(e =>
      e.id === updatedExpense.id ? updatedExpense : e
    ));
  }, []);

  const deleteExpense = useCallback((id) => {
    setExpenses(prev => prev.filter(e => e.id !== id));
  }, []);

  const getExpenseById = useCallback((id) => {
    return expenses.find(e => e.id === id);
  }, [expenses]);

  // Income rows: bank credits or manually marked income
  // Expense rows: everything else (charges, debits)
  const totalSpend = expenses.reduce((sum, e) => {
    if (e.transactionDirection === 'credit') return sum;
    const amount = e.convertedTotal ?? parseFloat(e.total) ?? 0;
    return sum + amount;
  }, 0);

  const totalIncome = expenses.reduce((sum, e) => {
    if (e.transactionDirection !== 'credit') return sum;
    const amount = e.convertedTotal ?? parseFloat(e.total) ?? 0;
    return sum + amount;
  }, 0);

  return {
    expenses,
    setExpenses,
    addExpense,
    addExpenses,
    updateExpense,
    deleteExpense,
    getExpenseById,
    totalSpend,
    totalIncome,
  };
};
